import 'javascripts/all_pages.js'
import { stickyScroll } from 'javascripts/general_scripts';

jQuery(() => {
  stickyScroll();
});